var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState, forwardRef, useMemo } from "react";
import classNames from "classnames";
import "@gouvfr/dsfr/dist/component/form/form.css";
import "@gouvfr/dsfr/dist/component/input/input.css";
import "@gouvfr/dsfr/dist/component/search/search.css";
import generateID from "../../../utils/string-utils";
/**
 * @deprecated utiliser `SearchBarV2`. Sera supprimé dans une futur Release d'ici fin 2025.
 */
var SearchBar = forwardRef(function (props, ref) {
    var id = props.id, _a = props.size, size = _a === void 0 ? "md" : _a, _b = props.label, label = _b === void 0 ? "Recherche" : _b, btnLabel = props.btnLabel, onSearch = props.onSearch, className = props.className, _c = props.defaultValue, defaultValue = _c === void 0 ? "" : _c, _d = props.placeholder, placeholder = _d === void 0 ? "Rechercher" : _d, name = props.name, 
    // @ts-ignore
    __TYPE = props.__TYPE, remainingProps = __rest(props, ["id", "size", "label", "btnLabel", "onSearch", "className", "defaultValue", "placeholder", "name", "__TYPE"]);
    var inputId = useMemo(function () { return id || generateID(); }, [id]);
    var _e = useState(defaultValue), search = _e[0], setSearch = _e[1];
    var _className = classNames("fr-search-bar", "fr-search-bar--".concat(size), __TYPE, className);
    var _classNameButton = classNames("fr-btn", {
        "fr-btn--lg": size === "lg",
    });
    var onKeyDown = function (e) { return e.keyCode === 13 && onSearch(search); };
    return (React.createElement("div", { className: _className, role: "search" },
        label && (React.createElement("label", { className: "fr-label", htmlFor: inputId }, label)),
        React.createElement("input", __assign({ className: "fr-input", type: "search", name: name || inputId, placeholder: placeholder, onChange: function (e) { return setSearch(e.target.value); }, onKeyDown: onKeyDown, id: inputId }, remainingProps, { ref: ref })),
        React.createElement("button", { className: _classNameButton, title: btnLabel, onClick: function () { return onSearch(search); } }, btnLabel)));
});
export default SearchBar;
